import styled from "@emotion/styled";
import { Icon } from "@mindlercare/ui-web";
import { defaultTheme } from "@mindlercare/ui-web/src/shared/constants";
import { LinkButton } from "../components/LinkButton";
import { useStateNavigator } from "../hooks/useStateNavigator";
import { useTranslation } from "../hooks/useTranslation";

export const BackToLogin = () => {
  const { goBack } = useStateNavigator();
  const { t } = useTranslation();

  return (
    <Root>
      <Icon.ChevronLeft />
      <LinkButton
        onClick={() => {
          goBack();
        }}
      >
        {t("BACK_TO_LOG_IN")}
      </LinkButton>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: ${defaultTheme.MARGIN.LG} 0;
`;
